export default __webpack_public_path__ + "static/media/basketball-icon.800d3cdc.svg";